module.exports = __webpack_public_path__ + "img/consultant_process.68cf2e45.png";